import Vue from 'vue'

export class Supers {
  public static supers: Supers

  /**
   * 获取 exportExcel 单例对象
   *
   * @static
   * @returns {exportExcel}
   * @memberof exportExcel
   */
  public static getInstance(): Supers {
    if (!Supers.supers) {
      Supers.supers = new Supers();
    }
    return this.supers;
  }

  private constructor() { }

  public init(parentClass: typeof Vue, method: string, params: any[], vm: Vue){
    let proto = function() {}
    const temp = Object.setPrototypeOf(proto.prototype, parentClass);
    let parentMethod
    try {
      parentMethod = Object.getPrototypeOf(temp).extendOptions.methods[method]
    } catch(error) {
      console.error(`[${method}]转换错误!`, error);
    }
    if (parentMethod) {
      return parentMethod.apply(vm, params)
    }
  }
}